import TermsOfUseLink from '@components/TermsOfUse/TermsOfUseLink';
import HomeCopyright from './HomeCopyright';
import { Animated } from '@components/Animated';
import { IDataTestId } from '@custom';

type TProps = { isSubmitting?: boolean } & IDataTestId;

const HomeContainerFooter = ({ isSubmitting = false, ...rest }: TProps) => {
  return (
    <Animated
      animationInDelay={1000}
      animationInDuration={1200}
      animationOutDuration={1000}
      className={'tw:mt-8 tw:font-thin tw:flex tw:justify-center tw:w-full'}
      onClick={undefined}
      innerRef={undefined}
    >
      <HomeCopyright />
      {!isSubmitting && (
        <TermsOfUseLink
          data-testid={rest['data-testid'] ? `${rest['data-testid']}-terms-of-use-link` : undefined}
        />
      )}
    </Animated>
  );
};

export default HomeContainerFooter;
